
export default function ValuesSection() {
  const values = [
    {
      icon: 'ri-shield-check-line',
      title: 'Güvenilirlik',
      description: 'Müvekkillerimizin güvenini kazanmak ve korumak en önemli önceliğimizdir.'
    },
    {
      icon: 'ri-eye-line',
      title: 'Şeffaflık',
      description: 'Tüm süreçlerde açık ve net iletişim kurarak müvekkillerimizi bilgilendiririz.'
    },
    {
      icon: 'ri-award-line',
      title: 'Mükemmellik',
      description: 'Her davada en iyi sonucu elde etmek için titizlikle çalışırız.'
    },
    {
      icon: 'ri-heart-line',
      title: 'Empati',
      description: 'Müvekkillerimizin durumunu anlayarak kişiselleştirilmiş çözümler sunarız.'
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 animate-fade-in-up">
          <h2 className="text-3xl font-bold text-slate-900 mb-4 font-poppins">
            Değerlerimiz
          </h2>
          <div className="w-16 h-0.5 bg-slate-900 mx-auto mb-6"></div>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto font-poppins font-light">
            Çalışmalarımızı yönlendiren temel değerler ve ilkelerimiz
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {values.map((value, index) => (
            <div 
              key={index} 
              className="text-center p-6 rounded-lg bg-gray-50 hover-lift animate-fade-in-up"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="w-16 h-16 bg-slate-900 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className={`${value.icon} text-2xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3 font-poppins">
                {value.title}
              </h3>
              <p className="text-slate-600 leading-relaxed font-poppins font-light">
                {value.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}